import React, {useEffect, useState} from "react";
import "./Events.css";
import Carousel from "./Carousel/Carousel";
import axios from "axios";

const Events = ({content}) => {

    const [events, setEvents] = useState(null);

    useEffect(() => {
        axios.get("https://www.agricolart.it/api/events/").then((res) => {
            console.log(res.data);
            setEvents(res.data);
        })
    }, [])

    if (!events) return null;

    return(
        <section className="events">
            <h1>{content.title}</h1>
            <Carousel events={events} content={content}/>
        </section>
    )
}

export default Events;
